import { enTranslations } from './enTranslations/index';
import { heTranslations } from './heTranslations';
import { DEFAULT_NS } from './types';

export const resources = {
  en: {
    [DEFAULT_NS]: enTranslations,
  },
  he: {
    [DEFAULT_NS]: heTranslations,
  },
};
